import { useIntl } from 'react-intl';
import { Routes, Route } from 'react-router-dom';
import RouteWrapper from '../common/RouteWrapper';
import SuccessRoute from './Success';

const PaymentRoutes = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route
        path="success"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'paymentSuccess.seo.title',
              defaultMessage: 'ClearVPN | Success',
              description: 'SEO title of the page, where user ends after purchase from 3rd party service',
            })}
          >
            <SuccessRoute />
          </RouteWrapper>
        }
      />
    </Routes>
  );
};

export default PaymentRoutes;
